import { useState } from "react";
import { FlaskConical, RotateCcw, Eraser, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

const ACTIONS = {
  reset: {
    title: "Reset Data Simulasi?",
    desc: "Semua data contoh akan dikembalikan ke kondisi awal. Catatan asli yang Anda buat sendiri tidak akan dihapus atau diubah.",
    confirm: "Ya, Reset Data Simulasi", url: "/simulation/reset", ok: "Data simulasi berhasil dikembalikan ke kondisi awal.",
  },
  clear: {
    title: "Mulai dengan Data Kosong?",
    desc: "Semua transaksi contoh beserta pembayaran, kasbon, pergerakan stok, dan saldo contoh akan dihapus permanen. Catatan asli Anda tetap aman.",
    confirm: "Ya, Hapus Data Contoh", url: "/simulation/clear", ok: "Data simulasi berhasil dihapus. Sekarang Anda bisa mulai mencatat usaha sendiri.",
  },
};

export function SimButtons({ compact }) {
  const { bump } = useAuth();
  const [which, setWhich] = useState(null);
  const [busy, setBusy] = useState(false);
  const a = which && ACTIONS[which];
  const run = async () => {
    setBusy(true);
    try { await api.post(a.url); await bump(); toast.success(a.ok); setWhich(null); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };
  const cls = compact ? "jt-btn min-h-[2.4rem] py-1.5 px-3 text-sm" : "jt-btn";
  return (
    <>
      <button className={`${cls} jt-btn-ghost`} onClick={() => setWhich("reset")} data-testid="sim-reset-button"><RotateCcw className="w-4 h-4" /> Reset Data Simulasi</button>
      <button className={`${cls} bg-[var(--jt-emerald-2)] text-white hover:bg-[var(--jt-emerald)]`} onClick={() => setWhich("clear")} data-testid="sim-clear-button"><Eraser className="w-4 h-4" /> Mulai dengan Data Kosong</button>
      <AlertDialog open={!!which} onOpenChange={(o) => !o && !busy && setWhich(null)}>
        <AlertDialogContent data-testid="sim-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{a?.title}</AlertDialogTitle>
            <AlertDialogDescription>{a?.desc}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={busy} data-testid="sim-confirm-cancel">Batal</AlertDialogCancel>
            <AlertDialogAction disabled={busy} onClick={(e) => { e.preventDefault(); run(); }} className="bg-[var(--jt-emerald-2)] hover:bg-[var(--jt-emerald)]" data-testid="sim-confirm-ok">
              {busy && <Loader2 className="w-4 h-4 animate-spin mr-2" />} {a?.confirm}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}

export function SimBanner() {
  const { ws } = useAuth();
  if (!ws?.simulation_mode) return null;
  return (
    <div className="mx-4 sm:mx-6 lg:mx-10 mt-4 rounded-2xl border border-[var(--jt-gold)]/40 bg-[#fdf3d8] px-4 py-3 flex flex-col md:flex-row md:items-center gap-3 no-print" data-testid="simulation-banner">
      <div className="flex items-start gap-3 flex-1">
        <FlaskConical className="w-5 h-5 text-[#9a7420] shrink-0 mt-0.5" />
        <p className="text-sm text-[#6b4f12]"><b>MODE SIMULASI — Data contoh, bukan catatan usaha asli.</b> Data bertanda “Contoh” hanya untuk mencoba aplikasi.</p>
      </div>
      <div className="flex flex-wrap gap-2"><SimButtons compact /></div>
    </div>
  );
}
